import { render, staticRenderFns } from "./addTeam.vue?vue&type=template&id=6d90b781&"
import script from "./addTeam.vue?vue&type=script&lang=js&"
export * from "./addTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d90b781')) {
      api.createRecord('6d90b781', component.options)
    } else {
      api.reload('6d90b781', component.options)
    }
    module.hot.accept("./addTeam.vue?vue&type=template&id=6d90b781&", function () {
      api.rerender('6d90b781', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teammanagemant/teamList/component/addTeam.vue"
export default component.exports